<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'franquias' })"
            :disabled="criandoFranquia"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Unidade Escolar
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="criandoFranquia">
        <v-row>
          <v-col class="pt-0 pb-0" cols="8">
            <e-label>Nome da Unidade</e-label>
            <ValidationProvider name="Nome" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.descricao" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>INEP</e-label>
            <ValidationProvider name="Inep" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.codigo" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12">
            <h1>Endereço</h1>
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>CEP</e-label>
            <v-text-field v-mask="'#####-###'" v-model="form.cep" solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="8">
            <e-label>Cidade</e-label>
            <ValidationProvider name="Cidade" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.cidade" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Estado</e-label>
            <ValidationProvider name="Estado" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.estado" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Bairro</e-label>
            <ValidationProvider name="Bairro" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.bairro" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Logradouro</e-label>
            <ValidationProvider name="Logradouro" rules="required" v-slot="{ errors }">
              <v-text-field v-model="form.logradouro" solo :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Número</e-label>
            <v-text-field v-model="form.numero" solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Telefone</e-label>
            <v-text-field v-mask="'(##) ####-####'" v-model="form.telefone" solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Celular 1</e-label>
            <v-text-field v-mask="'(##)# ####-####'" v-model="form.celular" solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Celular 2</e-label>
            <v-text-field v-mask="'(##)# ####-####'" v-model="form.celular2" solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Contexto</e-label>
            <v-text-field v-model="form.contexto" solo />
          </v-col>
          <v-col cols="12">
            <v-btn
              color="primary"
              :disabled="criandoFranquia"
              :loading="criandoFranquia"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    franquia(franquiaValue) {
      if (!franquiaValue) {
        this.form = {};
        return;
      }
      this.form = {
        ...franquiaValue,
      };
    },
    form: {
      async handler(formValue) {
        try {
          const cepValue = this.$services.cepService.getCepInteiro(formValue.cep);
          if (cepValue) {
            const localizacao = await this.$services.cepService.buscarDadosDoCep(cepValue);
            if (localizacao.cidade && localizacao.estado) {
              this.form.cidade = localizacao.cidade;
              this.form.estado = localizacao.estado;
            }
            if (localizacao.bairro && localizacao.rua) {
              this.form.bairro = localizacao.bairro;
              this.form.logradouro = localizacao.rua;
            }
          }
        } catch (error) {
          this.$handleError("Erro ao buscar informações do CEP");
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const { franquia_id } = this.$route.params;
    this.form = await this.$services.franquiasService.getFranquia(franquia_id);
  },
  data() {
    return {
      criandoFranquia: false,
      form: {},
    };
  },
  methods: {
    async submitForm(event) {
      this.criandoFranquia = true;
      try {
        if (this.editing) {
          await this.$services.franquiasService.atualizarFranquia(this.form);
        } else {
          await this.$services.franquiasService.criarFranquia(this.form);
        }
        this.$toast.success("Unidade Escolar Atualizada com sucesso");
        this.$router.push({ name: "franquias" });
      } catch (error) {
        this.$handleError(error);
      }
      this.criandoFranquia = false;
    },
  },
};
</script>

<style></style>
